import React, {useEffect, useMemo, useState} from 'react';
import Layout from '../Shared/Layout';
import {
    Container,
    Grid,
    Collapse,
    Box,
    IconButton,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import styled from "styled-components";
import EditIcon from '@material-ui/icons/Edit';
import { Inertia } from '@inertiajs/inertia'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import FormPage from "../Shared/FormPage";
import {InertiaLink} from "@inertiajs/inertia-react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import TextField from "@material-ui/core/TextField";
import StatusFlow from "../Shared/StatusFlow/StatusFlow";
import MuiButton from "@material-ui/core/Button";
import FormField from "../Shared/FormField";
import {Button} from "../Shared/Button";
import {Field, Form as FinalForm} from "react-final-form";
import TextInput from "../Shared/TextInput";
import Select from "../Shared/Select";
import BackButton from "../Shared/BackButton";
import {getCookieValue} from "../utils/getCookieValue";
import DateSelect from "../Shared/DateSelect";
import { Trans } from "../utils/i18n";
import QueueDetailDropzone from '../Shared/QueueDetailDropzone';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import {appointment} from "../config/appointment";
import {queueDetailConfigPyramid} from "../config/queueDetailPyramid";
import {Chat} from "../Shared/Chat";
import dayjs from "dayjs";
import Paper from '@material-ui/core/Paper';
import {Alert} from "@material-ui/lab";
import {resolveClientConfig} from "../utils/resolveClientConfig";
import {Step, StepLabel, Stepper} from "@material-ui/core";
import DateTimepicker from '../Shared/DateTimepicker';
import {AddressShowEdit} from "../Shared/AddressShowEdit";
import { FormState } from '../FormComponents/FormState';

const Wrapper = styled.div`
`;

const StyledContentWrapper = styled.div`
    display: flex;
`;

const DetailsHeading = styled.h4`
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 0;
`;

const DetailsValue = styled.h4`
    font-size: 16px;
    font-weight: 500;
    margin-top: 5px;
    position: relative;
`;

const EditButton = styled.div`
    position: absolute;
    top: 0;
    right: 15px;
    cursor: pointer;
`;

const ActionRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
`;

const HR = styled.hr`
    display: flex;
    justify-content: flex-end;
    margin: 15px 0;
`;

const ResponseWrapper = styled.div`
    width: 100%;
    margin-top: 30px;
`;

const StyledChatWrapper = styled.div`
    flex-basis: 100%;
    max-width: 430px;
    max-height: 100vh;
    height: fit-content;
    overflow-y: auto;
    margin-top: 30px;
    margin-left: 50px;
    padding-left: 50px;
    border-left: 1px solid #333333;

    @media(min-width: 800px) {
        max-width: 33.33%;
        flex-basis: 33.33%;
    }
`;

const OpenInTrackTrace = styled.a`
    font-size: 14px;
    text-decoration: none;
    margin-left: 15px;
    color: ${props => props.theme.secondary};
    display: inline-flex;
    align-items: end;
`;

const OpenInTrackTraceIcon = styled.svg`
    height: 18px;
    margin-right: 5px;
`;

const useStyles = makeStyles({
    root: {
        marginRight: '15px',
    },
});

const Heading = styled.h1`
    font-size: 24px;

    @media(min-width: 800px) {
        font-size: 40px;
    }
`;

const ColumnLeft = styled.div`
    max-width: 100%;
    flex-basis: 100%;

    @media(min-width: 800px) {
        max-width: 66.66%;
        flex-basis: 66.66%;
    }
`;

const createConditionFilter = (values, state) => (fieldOrGroup, step) => {
    if (!fieldOrGroup.condition) {
        return true;
    }

    const paths =
        fieldOrGroup.condition.field
            .replace(/\[(.*)\]/gm, '.$1')
            .split('.');

    let value = paths.reduce((values, path) => values[path], values);

    if(fieldOrGroup.condition.compare === '!=') {
        if(value === undefined) {
            return null !== fieldOrGroup.condition.value;
        }
        return value !== fieldOrGroup.condition.value;
    }

    return value === fieldOrGroup.condition.value;
};

export default function QueueDetail({ client, order, statuses, services, partners,
    coverages, settlements, materialOperations,
    files, userCanUpdate, orderattributes,
    orderhistories, extendedMode, permissions, returnUrl,
}) {
    const [formState, setFormState] = useState(undefined);
    const [response, setResponse] = useState(undefined);
    const classes = useStyles();
    const [editAddress, setEditAddress] = useState(false);

    const onSubmit = async (data) => {
        setFormState('loading');
        await fetch(route('queue.store'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                ...data,
                returnUrl,
            })
        })
            .then(res => res.json())
            .then(response => {
                if(response.success) {
                    setFormState('success');
                    setResponse('');
                    Inertia.visit(returnUrl || route('queue.index', { requesttype: order.requesttype_key }));
                    return
                }
                setResponse(response);
                setFormState('error');
            })
            .catch(() => {
                setFormState('error');
            })
    };


    const [open, setOpen] = React.useState(false);
    const [open_status, setOpenStatus] = React.useState(false);

    let activeStep;

    const StatusCreated = statuses.find(item => item.key === 'created');
    const StatusAppointment = statuses.find(item => item.key === 'appointment');
    const StatusVisit = statuses.find(item => item.key === 'visit');
    const StatusClosed = statuses.find(item => item.key === 'closed');

    if(orderhistories.find(item => item.status_id === StatusCreated?.id)) {
        activeStep = 0;
    }

    if(orderhistories.find(item => item.status_id === StatusAppointment?.id)) {
        activeStep = 1;
    }

    if(orderhistories.find(item => item.status_id === StatusVisit?.id)) {
        activeStep = 2;
    }

    if(orderhistories.find(item => item.status_id === StatusClosed?.id)) {
        activeStep = 3;
    }

    return (
        <FormState>
            <Wrapper>
                <Container maxWidth="lg">
                    <StyledContentWrapper>
                        <ColumnLeft>
                            <BackButton label={<Trans i18nKey="queueDetail.queues">Queues</Trans>} href={returnUrl || route('queue.index', { requesttype: order.requesttype_key })}/>

                            <Heading>
                                <Trans i18nKey="queueDetail.jobDetail">Job Detail</Trans>: { order.number }
                                <OpenInTrackTrace
                                    href={route('track.index', { serialnumber: order.number })}
                                    target={'_blank'}>
                                    <OpenInTrackTraceIcon aria-hidden="true" focusable="false" data-prefix="fas"
                                        data-icon="external-link-alt" role="img" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="svg-inline--fa fa-external-link-alt fa-w-16 fa-3x">
                                            <path fill="currentColor" d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z" className=""></path>
                                    </OpenInTrackTraceIcon> <Trans i18nKey="queueDetail.trackTrace">Track & Trace</Trans>
                                </OpenInTrackTrace>
                            </Heading>

                            {
                                client.key === 'sparkasse-offenburg' || client.key === 'b2x' &&
                                <Stepper activeStep={activeStep} alternativeLabel>
                                    <Step>
                                        <StepLabel><span style={{ fontSize: 14 }}>Order created</span></StepLabel>
                                    </Step>
                                    <Step>
                                        <StepLabel><span style={{ fontSize: 14 }}>Appointment scheduled</span></StepLabel>
                                    </Step>
                                    <Step>
                                        <StepLabel><span style={{ fontSize: 14 }}>Onsite visit completed</span></StepLabel>
                                    </Step>
                                    <Step>
                                        <StepLabel><span style={{ fontSize: 14 }}>Job closed</span></StepLabel>
                                    </Step>
                                </Stepper>
                            }

                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    {
                                        editAddress !== 'installation_address' && <>
                                            <DetailsHeading><Trans i18nKey="queueDetail.address">Address</Trans></DetailsHeading>
                                            <DetailsValue>
                                                { order.installation_address.name }<br/>
                                                { order.installation_address.name_2 }<br/>
                                                { order.installation_address.street } { order.installation_address.housenumber }<br/>
                                                { order.installation_address.zip } { order.installation_address.city }<br/>
                                                { order.installation_address?.country?.name }
                                                {
                                                    order.permissions.updateAddress &&
                                                    <EditButton onClick={() => {
                                                        setEditAddress('installation_address');
                                                    }}><EditIcon/></EditButton>
                                                }
                                            </DetailsValue>
                                        </>
                                    }
                                    {
                                        editAddress === 'installation_address' &&
                                        <AddressShowEdit order={order} setEditAddress={setEditAddress} type={'installation_address'}/>
                                    }
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    {
                                        editAddress !== 'contact' && <>
                                            <DetailsHeading><Trans i18nKey="queueDetail.contact">Contact</Trans></DetailsHeading>
                                            <DetailsValue>
                                                {
                                                    order.installation_address.phone && <>
                                                        <div><PhoneIcon/> <span>{ order.installation_address.phone }</span></div>
                                                        <br/>
                                                    </>
                                                }
                                                {
                                                    order.installation_address.mobile && <>
                                                        <div><PhoneIphoneIcon/> <span>{ order.installation_address.mobile }</span></div>
                                                        <br/>
                                                    </>
                                                }
                                                {
                                                    order.installation_address.email &&
                                                    <div><EmailIcon/> <span>{ order.installation_address.email }</span></div>
                                                }
                                                {
                                                    order.permissions.updateAddress &&
                                                    <EditButton onClick={() => {
                                                        setEditAddress('contact');
                                                    }}><EditIcon/></EditButton>
                                                }
                                            </DetailsValue>
                                        </>
                                    }
                                    {
                                        editAddress === 'contact' &&
                                        <AddressShowEdit order={order} setEditAddress={setEditAddress} type={'contact'}/>
                                    }
                                </Grid>
                            </Grid>

                            {
                                order.collection_address &&
                                <Grid container spacing={3} >
                                    <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>

                                        {
                                            editAddress !== 'collection_address' && <>
                                                <DetailsHeading>
                                                    <Trans i18nKey="queueDetail.collectionAddress">Collection address</Trans>
                                                </DetailsHeading>
                                                <DetailsValue>
                                                    {order.collection_address?.name}<br/>
                                                    {order.collection_address?.name_2}<br/>
                                                    {order.collection_address?.street}<br/>
                                                    {order.collection_address?.zip} {order.collection_address?.city}<br/>
                                                    {order.collection_address?.country?.name}
                                                    {
                                                        order.permissions.updateAddress &&
                                                        <EditButton onClick={() => {
                                                            setEditAddress('collection_address');
                                                        }}><EditIcon/></EditButton>
                                                    }
                                                </DetailsValue>
                                            </>
                                        }
                                        {
                                            editAddress === 'collection_address' &&
                                            <AddressShowEdit order={order} setEditAddress={setEditAddress} type={'collection_address'}/>
                                        }
                                    </Grid>

                                    <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                                        {
                                            editAddress !== 'collection_contact' && <>
                                                <DetailsHeading><Trans i18nKey="queueDetail.collectionContact">Collection contact</Trans></DetailsHeading>
                                                <DetailsValue>
                                                    {
                                                        order.collection_address.phone && <>
                                                            <div><PhoneIcon/> <span>{ order.collection_address.phone }</span></div>
                                                            <br/>
                                                        </>
                                                    }
                                                    {
                                                        order.collection_address.email &&
                                                        <div><EmailIcon/> <span>{ order.collection_address.email }</span></div>
                                                    }
                                                    {
                                                        order.permissions.updateAddress &&
                                                        <EditButton onClick={() => {
                                                            setEditAddress('collection_contact');
                                                        }}><EditIcon/></EditButton>
                                                    }
                                                </DetailsValue>
                                            </>
                                        }
                                        {
                                            editAddress === 'collection_contact' &&
                                            <AddressShowEdit order={order} setEditAddress={setEditAddress} type={'collection_contact'}/>
                                        }
                                    </Grid>
                                </Grid>
                            }

                            {
                                extendedMode && order.invoice_address &&
                                <Grid container spacing={3} >
                                    <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>

                                        {
                                            editAddress !== 'invoice_address' && <>
                                                <DetailsHeading>
                                                    <Trans i18nKey="queueDetail.invoiceAddress">Invoice address</Trans>
                                                </DetailsHeading>
                                                <DetailsValue>
                                                    {order.invoice_address?.name}<br/>
                                                    {order.invoice_address?.name_2}<br/>
                                                    {order.invoice_address?.street}<br/>
                                                    {order.invoice_address?.zip} {order. invoice_address?.city}<br/>
                                                    {order.invoice_address?.country?.name}
                                                    {
                                                        order.permissions.updateAddress &&
                                                        <EditButton onClick={() => {
                                                            setEditAddress('invoice_address');
                                                        }}><EditIcon/></EditButton>
                                                    }
                                                </DetailsValue>
                                            </>
                                        }
                                        {
                                            editAddress === 'invoice_address' &&
                                            <AddressShowEdit order={order} setEditAddress={setEditAddress} type={'invoice_address'}/>
                                        }
                                    </Grid>

                                    <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                                        {
                                            editAddress !== 'invoice_contact' && <>
                                                <DetailsHeading><Trans i18nKey="queueDetail.invoiceContact">Invoice contact</Trans></DetailsHeading>
                                                <DetailsValue>
                                                    {
                                                        order.invoice_address.phone && <>
                                                            <div><PhoneIcon/> <span>{ order.invoice_address.phone }</span></div>
                                                            <br/>
                                                        </>
                                                    }
                                                    {
                                                        order.invoice_address.email &&
                                                        <div><EmailIcon/> <span>{ order.invoice_address.email }</span></div>
                                                    }
                                                    {
                                                        order.permissions.updateAddress &&
                                                        <EditButton onClick={() => {
                                                            setEditAddress('invoice_contact');
                                                        }}><EditIcon/></EditButton>
                                                    }
                                                </DetailsValue>
                                            </>
                                        }
                                        {
                                            editAddress === 'invoice_contact' &&
                                            <AddressShowEdit order={order} setEditAddress={setEditAddress} type={'invoice_contact'}/>
                                        }
                                    </Grid>
                                </Grid>
                            }

                            {
                                extendedMode &&
                                <>
                                    <HR/>
                                    <h3><Trans i18nKey="queueDetail.products">Product / Accessories</Trans></h3>
                                </>
                            }

                            {
                                extendedMode &&
                                <TableContainer>
                                    <Table size="small" aria-label={<Trans i18nKey="queueDetail.collapsibleTable">collapsible table</Trans>}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell />
                                                <TableCell><Trans i18nKey="queueDetail.product">Product</Trans></TableCell>
                                                <TableCell><Trans i18nKey="queueDetail.serialNumber">Serial number</Trans></TableCell>
                                                <TableCell align="left"><Trans i18nKey="queueDetail.quantity">Quantity</Trans></TableCell>
                                                {/*<TableCell align="left"><Trans i18nKey="queueDetail.grade">Grade</Trans></TableCell>*/}
                                                <TableCell align="left"><Trans i18nKey="queueDetail.faultcode">Fault code</Trans></TableCell>
                                                <TableCell align="left"><Trans i18nKey="queueDetail.problem">Problem</Trans></TableCell>
                                                <TableCell align="left"><Trans i18nKey="queueDetail.problemDescription">Problem description</Trans></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {order.products.map((product) => (
                                                <><TableRow key={product.number}>
                                                    <TableCell>
                                                        <IconButton aria-label={<Trans i18nKey="queues.expandRow">expand row</Trans>} size="small" onClick={() => setOpen(!open)}>
                                                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        {product.description}
                                                    </TableCell>
                                                    <TableCell>{product.serialnumber}</TableCell>
                                                    <TableCell>{product.quantity}</TableCell>
                                                    {/*<TableCell>{product.grade}</TableCell>*/}
                                                    <TableCell>{product.faultcode}</TableCell>
                                                    <TableCell>{product.problem}</TableCell>
                                                    <TableCell>{product.problem_description}</TableCell>
                                                    {/*<TableCell align="right">{historyRow.amount}</TableCell>*/}
                                                    {/*<TableCell align="right">*/}
                                                    {/*    {Math.round(historyRow.amount * row.price * 100) / 100}*/}
                                                    {/*</TableCell>*/}
                                                </TableRow><TableRow>
                                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0, width: '100%', }} colSpan={10}>
                                                            <Collapse in={open} timeout="auto" unmountOnExit>
                                                                <Box margin={1}>
                                                                <Typography variant="h6" gutterBottom component="div">
                                                                    <Trans i18nKey="queueDetail.outgoingProduct">Outgoing Product</Trans>
                                                                </Typography>
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell><Trans i18nKey="queueDetail.product">Product</Trans></TableCell>
                                                                                <TableCell><Trans i18nKey="queueDetail.serialNumber">Serial number</Trans></TableCell>
                                                                                <TableCell align="left"><Trans i18nKey="queueDetail.quantity">Quantity</Trans></TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            <TableRow>
                                                                                <TableCell component="th" scope="row">
                                                                                    {product.outgoingNumber}
                                                                                </TableCell>
                                                                                <TableCell>{product.outgoingSerialnumber}</TableCell>
                                                                                <TableCell>{product.outgoingQuantity}</TableCell>
                                                                            </TableRow>
                                                                        </TableBody>
                                                                    </Table>
                                                                </Box>
                                                            </Collapse>
                                                        </TableCell>
                                                    </TableRow></>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }
                            {
                                extendedMode && <HR/>
                            }

                            <FinalForm
                                initialValues={order}
                                onSubmit={onSubmit}>
                                {({ handleSubmit, submitting, values, form, errors, touched }) => {

                                    const currentStatus = statuses.find(item => item.id == values.status_id);
                                    const currentService = services.find(item => item.id == values.service_id);
                                    const currentSettlement = settlements.find(item => item.id == values.settlement_id);
                                    const conditionFilter = useMemo(() => createConditionFilter(values), [values]);
                                    let preFix = '';

                                    return (
                                        <form onSubmit={handleSubmit}>
                                            <div>
                                                <Grid container spacing={3}>
                                                    {
                                                        extendedMode &&
                                                        <Grid item xs={12} sm={6}>
                                                            <h3><Trans i18nKey="queueDetail.jobType">Job type</Trans></h3>
                                                            <Field
                                                                name={'service_id'}
                                                                type={'select'}
                                                                // placeholder={field.placeholder}
                                                                component={Select}
                                                                // validate={field.required ? validate[field.type] || required : undefined}
                                                                field={{
                                                                    type: 'select',
                                                                    label: <Trans i18nKey="queueDetail.jobType">Job type</Trans>,
                                                                    "options": services.map(item => ({
                                                                        value: item.id,
                                                                        label: item.name
                                                                    })),
                                                                }}
                                                                disabled={submitting}
                                                            />
                                                        </Grid>
                                                    }
                                                    {
                                                        extendedMode &&
                                                        <Grid item xs={12} sm={6}>
                                                            <h3><Trans i18nKey="queueDetail.partner">Partner</Trans></h3>
                                                            <Field
                                                                name={'partner_id'}
                                                                type={'select'}
                                                                // placeholder={field.placeholder}
                                                                component={Select}
                                                                // validate={field.required ? validate[field.type] || required : undefined}
                                                                field={{
                                                                    type: 'select',
                                                                    label: <Trans i18nKey="queueDetail.partner">Partner</Trans>,
                                                                    "options": partners.map(item => ({
                                                                        value: item.id,
                                                                        label: item.name
                                                                    })),
                                                                }}
                                                                disabled={submitting}
                                                            />
                                                        </Grid>
                                                    }
                                                    {
                                                        extendedMode && currentService && (currentService.key === 'iw-self-repair' || currentService.key === 'oow-self-repair')  &&
                                                        <Grid key={'spareparts'} item xs={12} sm={'full'}>
                                                            <FormField
                                                                name={'spareparts'}
                                                                type={'metapicker'}
                                                                // placeholder={field.placeholder}
                                                                component={'metapicker'}
                                                                // validate={field.required ? validate[field.type] || required : undefined}
                                                                field={{
                                                                    type: 'metapicker',
                                                                    key: 'spareparts',
                                                                    name: 'spareparts',
                                                                    label: <Trans i18nKey="orderEntry.spareparts.label">Spare parts</Trans>,
                                                                }}
                                                                disabled={submitting}
                                                            />
                                                            {/* <FormField disabled={field.disabledFunction ? field.disabledFunction(values) : false} field={field} preFix={preFix} submitting={submitting} values={values} form={form} mutators={form.mutators} requesttypes={[]}/> */}
                                                        </Grid>
                                                    }
                                                </Grid>
                                                <HR/>
                                            </div>
                                            {
                                                extendedMode &&
                                                <div>
                                                    <h3>Status</h3>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Field
                                                                name={'status_id'}
                                                                type={'select'}
                                                                // placeholder={field.placeholder}
                                                                component={Select}
                                                                // validate={field.required ? validate[field.type] || required : undefined}
                                                                field={{
                                                                    disableUnselected: true,
                                                                    type: 'select',
                                                                    label: <Trans i18nKey="queueDetail.status">Status</Trans>,
                                                                    "options": statuses.map(item => ({
                                                                        value: item.id,
                                                                        label: item.name,
                                                                    })),
                                                                }}
                                                                disabled={submitting}
                                                            />
                                                            <div style={{marginTop: 15}}/>
                                                            {
                                                                currentStatus && (currentStatus.key === 'appointment' || currentStatus.key === 'pickup-arrangement') &&
                                                                <Field
                                                                    name={'appointment_date'}
                                                                    // placeholder={field.placeholder}
                                                                    component={DateTimepicker}
                                                                    // validate={field.required ? validate[field.type] || required : undefined}
                                                                    field={{
                                                                        label: <Trans i18nKey="queueDetail.appointmentDate">Appointment date</Trans>,
                                                                        type: 'text',
                                                                    }}
                                                                    disabled={submitting}
                                                                />
                                                            }
                                                            {
                                                                currentStatus && currentStatus.key === 'shipped' &&
                                                                <Field
                                                                    name={'trackingcode'}
                                                                    component={TextInput}
                                                                    field={{
                                                                        label: <Trans i18nKey="queueDetail.trackingcode">Tracking Code</Trans>,
                                                                        type: 'text',
                                                                    }}
                                                                    disabled={submitting}
                                                                />
                                                            }
                                                            {
                                                                currentStatus && currentStatus.key === 'returnlabel' &&
                                                                <Field
                                                                    name={'returnlabel_trackingcode'}
                                                                    component={TextInput}
                                                                    field={{
                                                                        label: <Trans i18nKey="queueDetail.trackingcode">Tracking Code</Trans>,
                                                                        type: 'text',
                                                                    }}
                                                                    disabled={submitting}
                                                                />
                                                            }
                                                            {
                                                                currentStatus && currentStatus.key === 'diagnose' &&
                                                                <Field
                                                                    name={'settlement_id'}
                                                                    type={'select'}
                                                                    // placeholder={field.placeholder}
                                                                    component={Select}
                                                                    // validate={field.required ? validate[field.type] || required : undefined}
                                                                    field={{
                                                                        type: 'select',
                                                                        label: <Trans i18nKey="queueDetail.settlement">Settlement</Trans>,
                                                                        "options": settlements.map(item => ({
                                                                            value: item.id,
                                                                            label: item.name
                                                                        })),
                                                                    }}
                                                                    disabled={submitting}
                                                                />
                                                            }

                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Field
                                                                name={'status_exception'}
                                                                type={'text'}
                                                                // placeholder={field.placeholder}
                                                                component={TextInput}
                                                                // validate={field.required ? validate[field.type] || required : undefined}
                                                                field={{
                                                                    label: <Trans i18nKey="queueDetail.exceptionText">Exception text</Trans>,
                                                                    type: 'text',
                                                                }}
                                                                disabled={submitting}
                                                            />
                                                            <div style={{marginTop: 15}}/>
                                                            {
                                                                currentStatus && currentStatus.key === 'diagnose' && currentSettlement && currentSettlement.name === 'Repair' &&
                                                                <Field
                                                                    name={'materialOperations_id'}
                                                                    type={'select'}
                                                                    // placeholder={field.placeholder}
                                                                    component={Select}
                                                                    // validate={field.required ? validate[field.type] || required : undefined}
                                                                    field={{
                                                                        type: 'select',
                                                                        label: <Trans i18nKey="queueDetail.materialOperations">Operations</Trans>,
                                                                        "options": materialOperations.map(item => ({
                                                                            value: item.id,
                                                                            label: item.description
                                                                        })),
                                                                    }}
                                                                    disabled={submitting}
                                                                />
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <HR/>
                                                </div>
                                            }

                                            {
                                                extendedMode && orderhistories.length > 0 && <>
                                                    <h3><Trans i18nKey="queueDetail.orderHistory">Order history</Trans></h3>

                                                    <TableContainer component={Paper}>
                                                        <Table size="small" aria-label={<Trans i18nKey="queueDetail.aDenseTable">a dense table</Trans>}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        <IconButton aria-label={<Trans i18nKey="queues.expandRow">expand row</Trans>} size="small" onClick={() => setOpenStatus(!open_status)}>
                                                                                {open_status ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                        </IconButton>
                                                                    </TableCell>
                                                                    <TableCell><Trans i18nKey="queueDetail.history.date">Date</Trans></TableCell>
                                                                    <TableCell><Trans i18nKey="queueDetail.history.status">Status</Trans></TableCell>
                                                                    <TableCell><Trans i18nKey="queueDetail.history.carrier">Carrier</Trans></TableCell>
                                                                    <TableCell><Trans i18nKey="queueDetail.history.returnCarrier">Return carrier</Trans></TableCell>
                                                                    <TableCell><Trans i18nKey="queueDetail.history.collection">Pickup</Trans></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {orderhistories.map((item) => (
                                                                    <><TableRow key={item.id}>
                                                                        <TableCell>

                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {dayjs(item.updated_at).format('DD.MM.YYYY HH:mm')}
                                                                        </TableCell>
                                                                        <TableCell>{item.status}</TableCell>
                                                                        <TableCell>
                                                                            {item.carrier}<br />
                                                                            {item.carrier_tracking_ref}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {item.return_carrier}<br />
                                                                            {item.return_tracking_ref}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {
                                                                                item.pickup_number &&
                                                                                <span>
                                                                                    {item.pickup_number}<br />
                                                                                    {dayjs(item.pickup_readytime).format('DD.MM.YY HH:mm')} - {dayjs(item.pickup_closetime).format('HH:mm')}
                                                                                </span>
                                                                            }
                                                                        </TableCell>
                                                                    </TableRow><TableRow>
                                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0, width: '100%', }} colSpan={10}>
                                                                                <Collapse in={open_status} timeout="auto" unmountOnExit>
                                                                                    <Box margin={1}>
                                                                                        <Table size="small">
                                                                                            <TableHead>
                                                                                                <TableRow>
                                                                                                    <TableCell><Trans i18nKey="queueDetail.history.collectionDate">Collection date</Trans></TableCell>
                                                                                                    <TableCell><Trans i18nKey="queueDetail.history.deliveryDate">Delivery date</Trans></TableCell>
                                                                                                    <TableCell><Trans i18nKey="queueDetail.history.comment">Comment</Trans></TableCell>
                                                                                                    <TableCell><Trans i18nKey="queueDetail.history.exception">Exception</Trans></TableCell>
                                                                                                </TableRow>
                                                                                            </TableHead>
                                                                                            <TableBody>
                                                                                                <TableRow>
                                                                                                    <TableCell component="th" scope="row">
                                                                                                        {item.collection_datetime && dayjs(item.collection_datetime).format('DD.MM.YYYY HH:mm')}
                                                                                                    </TableCell>
                                                                                                    <TableCell component="th" scope="row">
                                                                                                        {item.delivery_datetime && dayjs(item.delivery_datetime).format('DD.MM.YYYY HH:mm')}
                                                                                                    </TableCell>
                                                                                                    <TableCell>{item.comment}</TableCell>
                                                                                                    <TableCell>{item.exception}</TableCell>
                                                                                                </TableRow>
                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    </Box>
                                                                                </Collapse>
                                                                            </TableCell>
                                                                        </TableRow></>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <HR/>
                                                </>
                                            }

                                            {
                                                extendedMode &&
                                                <div>
                                                    <h3><Trans i18nKey="queueDetail.serialNumber">Serial number</Trans></h3>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Field
                                                                name={'serialnumber'}
                                                                type={'text'}
                                                                // placeholder={field.placeholder}
                                                                component={TextInput}
                                                                // validate={field.required ? validate[field.type] || required : undefined}
                                                                field={{
                                                                    label: <Trans i18nKey="queueDetail.serialNumber">Serial number</Trans>,
                                                                    type: 'text',
                                                                }}
                                                                disabled={submitting}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Field
                                                                name={'outgoingSerialnumber'}
                                                                type={'text'}
                                                                // placeholder={field.placeholder}
                                                                component={TextInput}
                                                                // validate={field.required ? validate[field.type] || required : undefined}
                                                                field={{
                                                                    label: <Trans i18nKey="queueDetail.outgoingSerialNumber">Outgoing Serial number</Trans>,
                                                                    type: 'text',
                                                                }}
                                                                disabled={submitting}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <HR/>
                                                </div>
                                            }

                                            {
                                                orderattributes
                                                    .filter(item => item.key !== 'configurations')
                                                    .length > 0 && <>
                                                    <h3><Trans i18nKey="queueDetail.orderAttributes">Order attributes</Trans></h3>

                                                    <TableContainer>
                                                        <Table size="small"
                                                            aria-label={<Trans i18nKey="queueDetail.aDenseTable">a dense
                                                                table</Trans>}>
                                                            <TableBody>
                                                                {orderattributes
                                                                    .filter(item => item.key !== 'configurations')
                                                                    .map((attribute) => (
                                                                    <TableRow key={attribute.id}>
                                                                        <TableCell component="th" scope="row">
                                                                            {attribute.key}
                                                                        </TableCell>
                                                                        <TableCell>{attribute.value}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <HR/>
                                                </>
                                            }

                                            {
                                                extendedMode &&
                                                <div>
                                                    <h3><Trans i18nKey="queueDetail.files">Files</Trans></h3>
                                                    <QueueDetailDropzone enableType />
                                                </div>
                                            }
                                            {
                                                    extendedMode && coverages.count &&
                                                    <div>
                                                    <h3><Trans i18nKey="queueDetail.coverage">Coverage</Trans></h3>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Field
                                                                name={'coverage_id'}
                                                                type={'select'}
                                                                // placeholder={field.placeholder}
                                                                component={Select}
                                                                // validate={field.required ? validate[field.type] || required : undefined}
                                                                field={{
                                                                    type: 'select',
                                                                    label: <Trans i18nKey="queueDetail.coverage">Coverage</Trans>,
                                                                    "options": coverages.map(item => ({
                                                                        value: item.id,
                                                                        label: item.name
                                                                    })),
                                                                }}
                                                                disabled={submitting}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <HR/>
                                                </div>
                                            }

                                            {
                                                resolveClientConfig(client.key) &&
                                                resolveClientConfig(client.key).groups.map((group, index) => {
                                                    const fields = group.fields.map((field, index) => {
                                                        const size = resolveClientConfig(client.key).sizes[field.size ? field.size : 'full'];

                                                        return (field.conditionFunction ? field.conditionFunction(values, {statuses}) : true) && conditionFilter(field) && (
                                                            <Grid key={index} item xs={12} sm={size}>
                                                                <FormField disabled={field.disabledFunction ? field.disabledFunction(values) : false} field={field} preFix={preFix} submitting={submitting} values={values} form={form} mutators={form.mutators} requesttypes={[]}/>
                                                            </Grid>
                                                        );
                                                    });
                                                    return (group.conditionFunction ? group.conditionFunction(values, {statuses}) : true) && conditionFilter(group) && (
                                                        <div key={index}>
                                                            <div>
                                                                <div>
                                                                    {group.heading && (
                                                                        <h3>
                                                                            {group.heading}
                                                                        </h3>)}
                                                                    {group.description && (
                                                                        <p>
                                                                            {group.description}
                                                                        </p>)}
                                                                </div>
                                                            </div>
                                                            <Grid container spacing={3}>
                                                                {fields}
                                                            </Grid>
                                                            { resolveClientConfig(client.key).groups.length > index + 1 && <hr/>}
                                                        </div>
                                                    );
                                                })
                                            }

                                            <ActionRow>
                                                {
                                                    permissions.includes('queue_shipping_label') &&
                                                    <MuiButton
                                                        variant="contained"
                                                        color={'primary'}
                                                        disabled={submitting || currentStatus.key === 'created' || currentStatus.key === 'closed' || currentStatus.key === 'canceled'}
                                                        href={route('queue.shippinglabel', { ordernumber: order.number })}
                                                        target="_blank"
                                                    >
                                                        <Trans i18nKey="queueDetail.shippingLabelButton">CREATE SHIPPING LABEL</Trans>
                                                    </MuiButton>
                                                }
                                                {
                                                    extendedMode &&
                                                    <MuiButton
                                                        variant="contained"
                                                        disabled={submitting}
                                                        onClick={() => Inertia.visit(route('queue.index', { requesttype: order.requesttype_key }))}
                                                        className={classes.root}
                                                        style={{ marginLeft: 15 }}
                                                    >
                                                        <Trans i18nKey="queueDetail.cancel">Cancel</Trans>
                                                    </MuiButton>
                                                }
                                                <MuiButton
                                                    variant="contained"
                                                    color={'secondary'}
                                                    disabled={submitting || !userCanUpdate}
                                                    type={'submit'}
                                                    onClick={() => {
                                                        form.change('saveAndCloseJob', false);
                                                    }}
                                                >
                                                    <Trans i18nKey="queueDetail.save">Save</Trans>
                                                </MuiButton>
                                                {/* {
                                                    extendedMode == false &&
                                                    <MuiButton
                                                        variant="contained"
                                                        color={'secondary'}
                                                        disabled={submitting || !userCanUpdate || currentStatus.key === 'closed'}
                                                        type={'submit'}
                                                        style={{ marginLeft: 15 }}
                                                        onClick={() => {
                                                            form.change('saveAndCloseJob', true);
                                                        }}
                                                    >
                                                        <Trans i18nKey="queueDetail.saveAndClose">Save & close job</Trans>
                                                    </MuiButton>
                                                } */}
                                                <br/>
                                            </ActionRow>
                                            <ResponseWrapper>
                                                {
                                                    response?.message && <Alert severity="warning">{ response?.message }</Alert>
                                                }
                                            </ResponseWrapper>
                                        </form>
                                    )
                                }}
                            </FinalForm>
                        </ColumnLeft>
                        {
                            !extendedMode && <div></div>
                        }
                        {
                            extendedMode &&
                            <StyledChatWrapper>
                                <h2><Trans i18nKey="queueDetail.notes">Notes</Trans></h2>
                                <Chat />
                            </StyledChatWrapper>
                        }
                    </StyledContentWrapper>

                </Container>
            </Wrapper>
        </FormState>
    )
}

QueueDetail.layout = page => <Layout children={page} />;
